import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';
import { PermissionsLicensesLoader } from '@nextiva/global-store';
import {
  QueryClient as TanstackQueryClient,
  QueryClientProvider as TanstackQueryClientProvider,
} from '@tanstack/react-query';
import { QueryClient, QueryClientProvider } from 'react-query';

import App from './app';
import { ErrorBoundary } from 'UIElements';
import * as serviceWorker from './serviceWorker';
import { store as configureStore } from '_redux_';
import { ssoClientIds } from './ssoConfig';
const store = configureStore();

const env = (window.NextivaEnv || 'dev').toLowerCase();

const tanstackQueryClient = new TanstackQueryClient();
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  },
});

ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <TanstackQueryClientProvider client={tanstackQueryClient}>
        <PermissionsLicensesLoader
          ssoClientId={ssoClientIds[env]}
          userId={process.env.REACT_APP_SSO_USER_ID}
        >
          {props => (
            <Router>
              <ErrorBoundary>
                <App globalStoreData={props} />
              </ErrorBoundary>
            </Router>
          )}
        </PermissionsLicensesLoader>
      </TanstackQueryClientProvider>
    </QueryClientProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
